import { Alerts } from './component-main';
import { trionlineAjax } from './component-trionline';
export const DoAjax = input => {
    let { url } = input;
    let { data } = input;
    let { success } = input;
    let { icon } = input;
    let { method } = input;
    let { cache } = input;
    let { dataType } = input;
    let { error } = input;
    if (!dataType) {
        dataType = 'html';
    }
    if (!cache) {
        cache = true;
    }
    icon = icon ? $(icon) : false;
    if (!method) {
        method = 'GET';
    }
    if (!success) {
        success = data => {
            if (data) {
                Alerts.Alert({ msg: 'Unexpected Error' });
                console.log(data);
            }
        };
    }
    if (!data) {
        data = {};
    }
    if (!error) {
        error = data => {
            console.log('AJAX ERROR');
            console.log(data);
        };
    }
    if (icon) {
        icon.html("<img class='ajax_ico' src='/static/img/ajax-loader.gif' alt='...' />");
    }
    if (url.slice(-3) === '.py' && url.indexOf('/') === -1) {
        url = `/py/${url}`;
        url = url.replace('/py//py', '/py/');
    }
    try {
        data.sid = $('#sid').val();
    }
    catch (error1) { }
    for (const key in data) {
        if (data.hasOwnProperty(key)) {
            data[key] = encodeURIComponent(data[key]);
        }
    }
    trionlineAjax({
        url,
        data,
        method,
        yes: success,
        no: error,
    });
};
//# sourceMappingURL=components-old.js.map